/**
 * Transition Proposals — list (read-only, `[PROPOSED]`).
 *
 * `frontend-entity-coverage §2.3`: TransitionProposal is PROPOSED, backed by
 * `/api/transition-proposals` + `POST …/approve|/reject` (`11 §3.8`). It is the
 * load-bearing human gate ("a new mouth, not new hands") surfaced on the
 * Process Graph and as this list (`frontend-display §7.2`). Discoverable
 * labeled-empty teaser until the endpoint ships.
 */
import { GitPullRequestArrow } from "@/components/ui/icon";

import { ProposedListPage } from "../_shared/ProposedModule";

export function TransitionProposalList() {
  return (
    <ProposedListPage
      title="Transition Proposals"
      description="The human gate for phase transitions — approve or reject an artifact's proposed move."
      icon={GitPullRequestArrow}
      endpoint="/api/transition-proposals"
      emptyTitle="No transition proposals yet"
      testId="transition-proposals-empty"
    />
  );
}

export default TransitionProposalList;
